/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};







ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: window.Shopify.routes.root + 'cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: window.Shopify.routes.root + 'cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON(window.Shopify.routes.root + 'cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: window.Shopify.routes.root + 'cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    $('#cartCountSecond').html(cart.item_count);
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      if(jQuery(".popupCloseTrigger").length) {
        jQuery(".addToCart").removeClass('is-added').addClass('adding');
        setTimeout(function() {
          jQuery(".popupCloseTrigger").click();
          document.getElementById('cartToggle').click();
        }, 2500);
      }

      // Remove any previous quantity errors
      $('.qty-error').remove();

      //Open mini cart
      setTimeout(function() {
        document.getElementById('cartToggle').click();
      }, 1500);

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    setTimeout(function() {
      $addToCart.removeClass('is-adding').addClass('is-added').delay(10000).queue(function(rvt) {
        $addToCart.removeClass('is-added');
        //Close mini cart
        //document.getElementById('cartToggle').click();
        rvt();
      });
      //$('#GoToCheckout').css('display', 'block');
    }, 1500);

    var addedProductSize = $('#product-selected-size').text();
    var addedAlertText = "You have added" + ' "' + addedProductSize + '" ' + "to basket";
    if (addedProductSize != "") {
      if ($(".added-size-visual")[0]){
          $('.added-size-visual').text(addedAlertText)
      } else {
          $( ".product-extra-metafields" ).after( "<p class='added-size-visual'>" + addedAlertText + "</p>" );
      }
    }

    

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $addToCart.addClass('disabled is-soldout').prop('disabled', true);
        $('.product-switcher').after('<div class="errors qty-error button-text">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();
    addCompareAtPrice(cart);

    // Show empty cart
    if (cart.item_count === 0) {
      var data = {},
          source = $("#CartEmptyTemplate").html(),
          template = Handlebars.compile(source);

      $cartContainer.append(template(data));
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);


        function addCompareAtPrice(cart) {

          cart.items.forEach(function(item) {
            $.ajax({
              url: window.Shopify.routes.root + 'products/' + item.handle + '.js',
              dataType: 'json',
              async: false,
              success: function(product){
                product.variants.forEach(function(variant) {
                  if (variant.compare_at_price != null && variant.id == item.variant_id)
                    item["compare_at_price"] = variant.compare_at_price;
                  else
                    item["compare_at_price"] = 0;
                });
              }
            });
          });

          return cart;
        }


    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_150x150_crop_center$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      // Create item's data object and add to 'items' array
      if(cartItem.compare_at_price == 0){
        if(cartItem.options_with_values[0].name != 'Title'){

          item = {
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            productID: cartItem.product_id,
            productType: cartItem.product_type,
            img: prodImg,
            name: cartItem.product_title.split("*")[0],
            variation: cartItem.variant_title,
            variants: cartItem.options_with_values,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
            vendor: cartItem.vendor,
            linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
            originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
          };
        }else{
           item = {
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            productID: cartItem.product_id,
            productType: cartItem.product_type,
            img: prodImg,
            name: cartItem.product_title.split("*")[0],
            variation: cartItem.variant_title,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
            vendor: cartItem.vendor,
            linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
            originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
          };
        }
      }    else {
        if(cartItem.options_with_values[0].name != 'Title'){

          item = {
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            productID: cartItem.product_id,
            productType: cartItem.product_type,
            img: prodImg,
            name: cartItem.product_title.split("*")[0],
            variation: cartItem.variant_title,
            variants: cartItem.options_with_values,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
            vendor: cartItem.vendor,
            linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
            originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
            itemLineCompareAtPrice: Shopify.formatMoney(cartItem.compare_at_price * cartItem.quantity, settings.moneyFormat)
          };
        }else{
           item = {
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            productID: cartItem.product_id,
            productType: cartItem.product_type,
            img: prodImg,
            name: cartItem.product_title.split("*")[0],
            variation: cartItem.variant_title,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
            vendor: cartItem.vendor,
            linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
            originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
            itemLineCompareAtPrice: Shopify.formatMoney(cartItem.compare_at_price * cartItem.quantity, settings.moneyFormat)
          };
        }
      }
      items.push(item);

    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      cartCount: cart.item_count,
      cartTitle: cart.item_count > 1 ? "Translation missing: en.cart.mini_cart.items_added_to_cart" : "Translation missing: en.cart.mini_cart.item_added_to_cart",
      subTotalPrice: Shopify.formatMoney(cart.items_subtotal_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));


    // Use the market/language root (e.g. /de-de/) so the cart page is rendered for the shopper's market
    fetch(window.Shopify.routes.root + "cart")
      .then((response) => {
        response
          .text()
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // Per-market free delivery threshold (minor units) from the cart-free-delivery section.
            // Texts come from data attributes on the template, which is rendered in the shopper's language.
            const freeDeliveryConfig = doc.querySelector(".js-free-delivery-config");
            const freeDeliveryThreshold = freeDeliveryConfig ? parseInt(freeDeliveryConfig.dataset.threshold, 10) || 0 : 0;
            const qualifiesForFreeShipping = freeDeliveryThreshold > 0 && cart.total_price >= freeDeliveryThreshold;
            const $freeShippingMessage = $cartContainer.find(".js-mini-free-shipping");
            $freeShippingMessage.text(qualifiesForFreeShipping ? $freeShippingMessage.data("qualified") : $freeShippingMessage.data("calculated"));

            const cartUpSell = doc.querySelector(".js-cart-upsell");
            $cartContainer.append(cartUpSell.outerHTML);
            cartCallback(cart);
            cartUpsellCallback();
          })
          .catch((e) => {
              console.warn("response.text error: ", e);
          });
      })
      .catch((err) => console.warn("Something went wrong.", err));

  };

  var cartUpsellCallback = function() {
    if (jQuery(".c-cart-upsell__grid.owl-carousel").length) {
      jQuery(".c-cart-upsell__grid.owl-carousel").owlCarousel({
        loop: false,
        margin: 8,
        nav: true,
        dots: false,
        drag: false,
        navText: [
        '<span class="icon icons"><i class="bx bx-chevron-left"></i></span>',
        '<span class="icon"><i class="bx bx-chevron-right"></i></span>',
      ],
      mouseDrag: false,
        responsive: {
          0: {
            items: 1.42,
            loop: true,
          },
          768: {
            items: 2,
          }
        },
      onInitialized: function (event) {
        upsellProductHandle();
      }
    });
    }
  }

  var upsellProductHandle = function(){
    const upSellProduct = document.querySelectorAll("#cartContainer .js-upsell-product").forEach((product) => {
        const productOptions = product.querySelectorAll(".js-options-selector");

        productOptions.forEach((option) => {
          option.addEventListener("click", (e) => {
              e.preventDefault();
              const optionWrapper = option.querySelector(".js-options-wrapper");
              if (optionWrapper) {
                  if (optionWrapper.classList.contains("is-active")) {
                      optionWrapper.classList.remove("is-active");
                  } else {
                      optionWrapper.classList.add("is-active");
                  }
              }
          });

          const optionValues = option.querySelectorAll(".js-option-value");
          optionValues.forEach((optionValue) => {
              optionValue.addEventListener("click", () => {
                  optionValues.forEach((value) => {
                      value.classList.remove("is-selected");
                  });

                  optionValue.classList.add("is-selected");

                  setLabelValue(optionValue.dataset.value, option);
                  updateSelects(option, optionValue, product);
                  updateVariant(product);
              });
          });
      });

      submitDataHandle(product);
    });
  }

    function setLabelValue (value, option) {
        const optionLabels = option.querySelectorAll(".js-option-label");
        optionLabels.forEach((optionLabel) => {
            optionLabel.innerHTML = value;
        });
    }

    function updateSelects(option, optionValue, product) {
        const changedOption = option.getAttribute("data-option_position");
        const op1 = product.querySelector(
            "[data-option_position='1'] .js-option-value.is-selected"

        );
        const productInfo = JSON.parse(
            product.querySelector("[data-product-info]")?.innerHTML ?? "{}"
        );
        const value = optionValue.getAttribute("data-value");
        const variants = productInfo.variants.filter((variant) => {
            if (changedOption === "1") return variant.options[0] === value;
            if (changedOption === "2" && op1)
                return (
                    variant.options[0] === op1.dataset.value &&
                    variant.options[1] === value
                );
            return false;
        });
        const option2 = product.querySelector("[data-option_position='2']");
        let shouldUpdateLabel = false;

        if (option2) {
            const option2Values = option2.querySelectorAll(".js-option-value") || "";

            if (changedOption === "1") {
                option2Values.forEach((option) => {
                    const isVariantPresent = variants.some(
                        (variant) => variant.option2 === option.dataset.value
                    );
                    option.hidden = !isVariantPresent;
                    if (
                        !isVariantPresent &&
                        option.classList.contains("is-selected")
                    ) {
                        option.classList.remove("is-selected");
                        shouldUpdateLabel = true;
                    }
                });
                if (shouldUpdateLabel === true)
                    setLabelValue("Please select", option2);
            }

            if (changedOption === "2" || changedOption === "1") {
                const option3 = product.querySelector("[data-option_position='3']");
                if (option3) {
                    const option3Values = option3.querySelectorAll(".js-option-value");
                    const selectedOption2 = option2.querySelector(".js-option-value.is-selected");
                    shouldUpdateLabel = false;

                    option3Values.forEach((option) => {
                        const isVariantPresent = variants.some((variant) => {
                            let isOkay =
                                variant.option3 === option.dataset.value;
                            if (selectedOption2 && isOkay) {
                                isOkay =
                                    variant.option2 ===
                                    selectedOption2.dataset.value;
                            }
                            return isOkay;
                        });
                        option.hidden = !isVariantPresent;
                        if (
                            !isVariantPresent &&
                            option.classList.contains("is-selected")
                        ) {
                            option.classList.remove("is-selected");
                            shouldUpdateLabel = true;
                        }
                    });
                    if (shouldUpdateLabel === true)
                        setLabelValue("Please select", option3);
                }
            }
        }
    }

    function updateVariant(product) {
        const op1 = product.querySelector(
            "[data-option_position='1'] .js-option-value.is-selected"
        );
        const op2 = product.querySelector(
            "[data-option_position='2'] .js-option-value.is-selected"
        );
        const op3 = product.querySelector(
            "[data-option_position='3'] .js-option-value.is-selected"
        );

        const variant = product.querySelector(".js-product-variant");
        const variantValues = variant.querySelectorAll("option");

        const optionElement = product.querySelector("[data-option_position='2']");
        const optionElement3 =  product.querySelector("[data-option_position='3']");

        const thisOptions = product.querySelectorAll(".js-options-selector", );

        if (optionElement) {
            const options = optionElement.querySelectorAll(".js-option-value");

            if (options.length > 0) {
                options.forEach((option) => {
                    const soldout = option.querySelector("span");
                    if (soldout) {
                        option.removeChild(soldout);
                    }
                });
            }
        }

        if (optionElement3) {
            const options = optionElement3.querySelectorAll(".js-option-value");

            if (options.length > 0) {
                options.forEach((option) => {
                    const soldout = option.querySelector("span");
                    if (soldout) {
                        option.removeChild(soldout);
                    }
                });
            }
        }

        let op1Value, op2Value, op3Value;

        if (op1) {
            op1Value = op1.dataset.value;
        }
        if (op2) {
            op2Value = op2.dataset.value;
        }
        if (op3) {
            op3Value = op3.dataset.value;
        }

        if (variantValues) {
            variantValues.forEach((value) => {
                if (value.dataset.option3) {
                    if (
                        op1Value === value.dataset.option1 &&
                        op2Value === value.dataset.option2 &&
                        op3Value === value.dataset.option3
                    ) {
                        setVariant(value, product);
                    }

                    if (
                        op1Value === value.dataset.option1 &&
                        op2Value === value.dataset.option2
                    ) {
                      thisOptions.forEach((option) => {
                            if (option.dataset.option_position === "3") {
                                const optionList = option.querySelectorAll(
                                    ".js-option-value"
                                );
                                optionList.forEach((optionEl) => {
                                    if (
                                        value.disabled &&
                                        value.dataset.option3 ===
                                            optionEl.dataset.value
                                    ){
                                        optionEl.appendChild(addlabel());
                                    }
                                });
                            }
                        });
                    }
                } else if (value.dataset.option2) {
                    if (op1Value === value.dataset.option1) {
                      thisOptions.forEach((option) => {
                            if (option.dataset.option_position === "2") {
                              const optionList = option.querySelectorAll(
                                    ".js-option-value"
                                );
                                optionList.forEach((optionEl) => {
                                    if (
                                        value.disabled &&
                                        value.dataset.option2 ===
                                            optionEl.dataset.value
                                    ){
                                        optionEl.appendChild(addlabel());
                                    }
                                });
                            }
                        });
                    }
                    if (
                        op1Value === value.dataset.option1 &&
                        op2Value === value.dataset.option2
                    ) {
                        setVariant(value, product);
                    }
                } else if (value.dataset.option1) {
                    if (op1Value === value.dataset.option1) {
                        setVariant(value, product);
                    }
                }
            });
        }
    }

    function setVariant(value, product) {
      console.log(value);
        let variantSku = value.getAttribute("data-sku");
        let option1 = value.getAttribute("data-option1");
        let option2 = value.getAttribute("data-option2");
        let option3 = value.getAttribute("data-option3");

        const submitBtn = product.querySelector(".js-product-form-submit");
        const variant = product.querySelector(".js-product-variant");
        const variantValues = variant.querySelectorAll("option");

        if (option1.includes("-")) {
            option1 = option1.replace("-", "");
        }

        if (variantSku.includes(option1)) {
            variantSku = variantSku.replace(option1, "");
        }

        if (option2.includes("-")) {
            option2 = option2.replace("-", "");
        }

        if (variantSku.includes(option2)) {
            variantSku = variantSku.replace(option2, "");
        }

        if (option3.includes("-")) {
            option3 = option3.replace("-", "");
        }

        if (variantSku.includes(option3)) {
            variantSku = variantSku.replace(option3, "");
        }

        if (!value.disabled) {
            variantValues.forEach((el) => {
                el.selected = false;
            });

            value.selected = true;
            submitBtn.classList.remove("is-soldout");
            submitBtn.removeAttribute("disabled");

            if (submitBtn) submitBtn.style.display = "flex";

            variant.dispatchEvent(new Event("change"));
        } else {
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.classList.add("is-soldout");
            }
        }
    }

    function addlabel() {
        const soldoutElement = document.createElement("span");

            soldoutElement.classList.add("c-product-options__soldout");
            soldoutElement.innerHTML = "Sold Out";
        return soldoutElement;
    }

    function submitDataHandle(product) {
      const form = product.closest(".js-product-form");
      const thisSubmit = product.querySelector(".js-product-form-submit");
      form.addEventListener("submit", (e) => {
        e.preventDefault();
      console.log(form);


        thisSubmit.setAttribute("disabled", true);

        toggleAddToCartText(".js-adding-text", thisSubmit);

        console.log(jQuery(form).serialize());
        ShopifyAPI.addItemFromForm(form, itemAddedCallback, itemErrorCallback);
        });


    }

    function   toggleAddToCartText(text, submitBtn) {
      submitBtn.querySelectorAll(".js-button-text").forEach((el) => {
        el.style.display = "none";
      });
      submitBtn.querySelector(text).style.display = "block";
    }

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('click', '.ajaxcart__remove-adjust', function(e) {
      e.preventDefault();
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = 0;

      if (line) {
        updateQuantity(line, qty, $el);

      }

    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');



      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = parseInt($el.val()),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          // if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
